import { createDynamicSlice } from ".";
import { brandsThunk, GetAllBrands } from "../thunks/brandThunk";

const brandsSlice = createDynamicSlice({
  name: "brandsSlice",
  thunk: brandsThunk,
});

const allBrandsSlice = createDynamicSlice({
  name: "allBrandsSlice",
  thunk: GetAllBrands,
});

export const brandsReducer = brandsSlice.reducer;
export const allBrandsReducer = allBrandsSlice.reducer;